import { Vue } from "vue-property-decorator";

const Rules = {
  Required: (v: any, or: boolean) => or || !!v || "必須項目です。",
  maxLenght: (length: number) => {
    return (val: unknown) => {
      if (typeof val === "string") {
        return val.length <= length || `${length}文字以内で入力してください`;
      }
      return true;
    };
  }
};

export default Vue.extend({
  name: "Forms",
  components: {},
  data() {
    return {
      valid: false,
      Rules
    };
  },
  computed: {},
  methods: {}
});
